export default __webpack_public_path__ + "static/media/home-split-portfolio-img-05.ee7b1d37.jpg";